<template>
  <RegisterModal
    v-model="modelValue"
    modalMaxWidth="45%"
    :title="i18n.global.t('pages.vehicles.form.iniFileSetting.gSensor.customValuePrompt')"
  >
    <template v-slot:content>
      <div class="d-flex justify-center">
        <div class="w-75 content-center">
          <v-text-field
            class="ma-2"
            :label="label"
            :messages="i18n.global.t('pages.vehicles.form.iniFileSetting.gSensor.accelerationSettingHint')"
            v-model="customValue"
            type="number"
            step="0.1"
          />
        </div>
      </div>
  </template>
  <template v-slot:buttons>
      <v-btn
      class="ma-2 reset-btn"
      @click="cancel"
      >
        {{ i18n.global.t('common.cancelBtn') }}
      </v-btn>
      <v-btn
      class="ma-2 exec-btn"
      @click="saveValue"
      >
        {{ i18n.global.t('common.saveBtn') }}
      </v-btn>
    </template>
  </RegisterModal>
</template>

<script setup lang="ts">
import RegisterModal from "@/components/Common/RegisterModal.vue"
import { ref, defineProps, defineEmits, computed, watch } from 'vue';
import i18n from '@/lang/i18n';

const props = defineProps<{
  modelValue: boolean,
  customValue: number,
  label: string
}>()

const customValue = ref(props.customValue);

const emit = defineEmits(['update:modelValue', 'update:customValue', 'clearCustomValue', 'saveCustomValue']);

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

watch(customValue, (newValue) => {
    emit("update:customValue", newValue);
});

function cancel() {
  emit('update:modelValue', false);
  emit('clearCustomValue');
}

function saveValue() {
  emit('update:modelValue', false);
  emit('saveCustomValue');
}
</script>